/* eslint-disable no-nested-ternary */
import React, { useCallback, useState, useEffect, useMemo } from 'react';
import {
    useFrontDeskState,
    useFrontDeskDispatch,
    SET_PREVIEW_MODE,
    TOGGLE_SET_DETAIL_OPEN,
    SET_DETAIL_OPEN,
    RESET,
    SET_MODIFIED,
    UPDATE_AGENDA_PROPERTIES,
} from 'context/frontdesk';
import { WorkflowsSelect, useWorkflowList } from 'components/Shared/Selects/WorkflowsSelect';
import { fetchDelegationRulesUnpopulated } from 'api/actions/delegation-rules';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import {
    Input,
    FormFeedback,
    FormGroup,
    Label,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Row,
    Navbar,
    Nav,
    Col,
    Media,
    NavItem,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Button,
    Form,
    Container,
    ButtonGroup,
    UncontrolledCollapse,
} from 'reactstrap';
import bootbox from 'components/Modals/Bootbox';
import { fileTypes } from '../../ContractList/CreateContract/Constants/types';
import { contractAction, saveContract } from 'api/actions/contracts';
import { useProfileState, useProfileAbility, useProfile } from 'context/profile';
import { uploadFileV2 } from 'api/actions/file';
import { fetchParticipant } from 'api/actions/agenda';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { fetcher } from 'api/client';
import AsyncSelect from 'react-select/async';
import DragZone from 'components/Shared/DragZone';
import DatePicker from 'components/Shared/DatePicker';
import { parseDate, noop } from 'utils';
import { toast } from 'components/Shared/Toast';
import Dropzone from 'react-dropzone';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { Vobo } from 'components/ContractDetail/Contents/Properties/Properties';
import { ParticipantsSelect } from 'components/Editor/Sidebar/Contents/Configuration/ParticipantList';
import { agendaFields } from 'components/Modals/AgendaModal'
import { getNodesByType } from 'components/Editor/Canvas/TratoFormat/editor-utils'
import useFileUpload from 'api/hooks/file/useFileUpload';
import { useEditor, Slate } from 'slate-react';
import { TratoFormat, getEditorInstance } from 'components/Editor/Canvas/TratoFormat';
import { useConstant } from 'hooks/useConstant';
import useWhoami from 'hooks/useWhoami';

import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

const monthStringToDate = {
    'enero': '01',
    'febrero': '02',
    'marzo': '03',
    'abril': '04',
    'mayo': '05',
    'junio': '06',
    'julio': '07',
    'agosto': '08',
    'septiembre': '09',
    'octubre': '10',
    'noviembre': '11',
    'diciembre': '12',
}

function transformDateString(variable) {
    const splitDate = variable.value.replace(/del/ig, '').replace(/de/ig, '').replace(/  +/ig, ' ').split(" ")

    return `${splitDate[2]}/${monthStringToDate[splitDate[1]]}/${splitDate[0]}`
}

function getVariableDateValue(variable) {
    if (variable.dateValue) return variable.dateValue;
    if (!variable.value || variable.value.length <= 0) return null;
    try {
        return new Date(transformDateString(variable))
    } catch (error) {
        return null;
    }

}

const Variable =
    // React.memo(
    ({ register, variable, control, documentLanguage, disabled, index, errors }) => {
        const { t } = useTranslation();
        return (
            <div className="participant-variables-item form-group d-flex flex-column">
                <label>{variable.name}</label>
                {
                    variable.type === 'fixed' ?
                        <select
                            name={`computedVariables.${variable.apiName}`}
                            defaultValue={variable.value}
                            className="form-control"
                            ref={register()}
                            disabled={disabled}
                        >
                            <option value=""></option>
                            {variable.options?.map((v, index) => (
                                <option key={`variable${v}${index}`} value={v}>
                                    {v}
                                </option>
                            ))}
                        </select>
                    : variable.type === 'date' ? 
                        <Controller
                            control={control}
                            name={`computedVariables.${variable.apiName}`}
                            defaultValue={getVariableDateValue(variable) || null}
                            render={({ onChange, onBlur, value }) => (
                                <DatePicker
                                    disabled={disabled}
                                    className="w-100"
                                    locale={documentLanguage}
                                    selected={value ? new Date(value) : null}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    customInput={<input className="form-control input-sm" type="text" />}
                                    dateFormat="PPP"
                                // placeholderText={t('editor.config.expiry_start_placeholder')}
                                />
                            )}
                        />
                    :
                        <input
                            disabled={disabled || variable?.type === 'dynamictable'}
                            ref={variable?.type !== 'dynamictable' ? register() : null}
                            name={`computedVariables.${variable.apiName}`}
                            type={variable.type}
                            className="form-control input-sm"
                            placeholder={variable.name}
                            defaultValue={variable.value}
                            invalid={!!errors?.computedVariables?.[variable.apiName]}
                        />
                }
                <div className="text-danger" hidden={!errors?.computedVariables?.[variable.apiName]}>
                    {/* {t(`errors.${errors?.computedVariables?.[variable.apiName]?.message}`)} */}
                    {t(`frontDesk.missing_field`)}
                </div>
            </div>
        );
    };
//     (prevProps, nextProps) => {
//         console.log({ prevProps, nextProps })
//         return prevProps.formState.isDirty === nextProps.formState.isDirty
//     }
// );

const Participant =
    // React.memo(
    ({ participant, name, register, control,  setValue, contract, index: participantIdx, disabled, errors }) => {

        const { t } = useTranslation();
        const dispatch = useFrontDeskDispatch();
        const editor = useEditor();

        const obligation = useWatch({
            control,
            name: `${name}.obligation`,
            defaultValue: participant.obligation,
        });

        const [hasAgendaFields, agendaFieldsInDocument] = useMemo(() => {
            const agendaVariables = [...getNodesByType(editor, 'variable', {
                match: (n) => n.participantId === participant._id && n.apiName?.includes(`agendaProperties`)
            })];
            return [!!agendaVariables.length, agendaVariables.map(([a]) => a.apiName)]
        }, [editor, participant._id])

        let fields = React.useMemo(
            () => [
                { name: 'obligation', type: 'select', options: ['individual', 'legal'] },
                { name: 'label', type: 'input', readonly: true },
                { name: 'email', type: 'input', required: true },
                { name: 'name', type: 'input', required: true },
                { name: 'last_name', type: 'input' },
                { name: 'representative', type: 'input', required: true },
                // { name: "label", type: 'input' },
                { name: 'phone', type: 'input' },
                { name: 'cargo', type: 'input' },
                { name: 'rg', type: 'input' },
                { name: 'cpf', type: 'input' },
            ],
            []
        );

        switch (contract?.jurisdiction) {
            case 'pr':
                fields = fields.filter((p) => !['rg'].includes(p.name));
                break;
            case 'br':
                break;
            default:
                fields = fields.filter((p) => !['cargo', 'rg', 'cpf'].includes(p.name));
                break;
        }

        const handleParticipantSelected = (part) => {
            console.log({participant})
            if (part) {
                setValue(`${name}.name`, obligation === 'individual' ? part.name : part.razonSocial)
                setValue(`${name}.last_name`, obligation === 'individual' ? part.last_name : '')
                setValue(`${name}.email`, part.value)
                setValue(`${name}.phone`, part.phone)
                setValue(`${name}.representative`, part.representanteLegal)
                if (part._id) setValue(`${name}.agendaProperties.agendaId`, part._id)
                // setValue(`${name}.agendaProperties.documents`, JSON.stringify(part?.documents));
                part.agendaId = part._id
                agendaFields.map(field => {
                        setValue(`${name}.agendaProperties.${field.propertyName}`, part?.[field.propertyName] || '')
                })
                dispatch({ type: UPDATE_AGENDA_PROPERTIES, participantId: participant._id , agendaProperties: part })
            } else {
                setValue(`${name}.name`, '')
                setValue(`${name}.last_name`, '')
                setValue(`${name}.email`, null)
                setValue(`${name}.phone`,'')
                setValue(`${name}.representative`, '')
                setValue(`${name}.agendaProperties.agendaId`, undefined)
                // setValue(`${name}.agendaProperties.documents`, '[]')
                agendaFields.map(field => {
                    setValue(`${name}.agendaProperties.${field.propertyName}`, '')
                })
                dispatch({ type: UPDATE_AGENDA_PROPERTIES, participantId: participant._id , agendaProperties: { documents: [] } })
            }
            
        }
     
        const handleRefetchAgendaPropertiese = async () => {
            console.log("Refetch agenda")
            if (!participant?.agendaProperties?._id) return;
            try {
                const result = await fetcher(fetchParticipant({ participantId: participant.agendaProperties.agendaId }))
                result.value = result.email;
                handleParticipantSelected(result)
                // handleChange()
                toast.success(t('Informacion actualizada'))
            } catch (error) {
                console.log({error})
                toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
            }
        }


        return (
            <Card className="mb-2 rounded-lg" key={`${participant._id}complete${participantIdx}`}>
                <CardHeader className="bg-light font-weight-bold rounded-lg-top text-center">
                    {participant.label}
                </CardHeader>

                <CardBody>
                    <span className="font-weight-bold">{t('frontDesk.generalInformation')}</span>
                    <input hidden={true} className="d-none" defaultValue={participant?._id} ref={register} name={`${name}._id`}></input>
                    <input hidden={true} className="d-none" defaultValue={participant?.label} ref={register} name={`${name}.label`}></input>
                    {fields.map((field, index) => {
                        return (obligation === 'individual' && field.name === 'representative') ||
                            (obligation === 'legal' && field.name === 'last_name') ? null : (
                            <FormGroup className="mt-4" key={participant?._id + field.name + index} id={participant?._id + field.name + index}>
                                <Label>
                                    {t(`frontDesk.${obligation === 'legal' && field.name === 'name' ? 'company_name' : field.name}`)}{' '}
                                    {field.required && '*'}
                                </Label>
                                {field.options ? (
                                    <select
                                        disabled={disabled}
                                        defaultValue={participant.obligation}
                                        name={`${name}.${field.name}`}
                                        className="form-control input-sm"
                                        required=""
                                        ref={register({ required: true })}
                                    >
                                        {field.options.map((o, index) => (
                                            <option value={o} key={o + index}>
                                                {t(`frontDesk.${o}`, { context: contract?.jurisdiction })}
                                            </option>
                                        ))}
                                    </select>
                                ) : field.name === 'email' ? (
                                    <Controller
                                        control={control}
                                        name={`${name}.email`}
                                        defaultValue={participant.email || null}
                                        render={({ onChange, onBlur, value}) => (
                                            <ParticipantsSelect
                                                onChange={(value, option) => {
                                                    handleParticipantSelected(option)
                                                    onChange(value)
                                                }}
                                                value={value}
                                                onBlur={onBlur}
                                                isDisabled={disabled}
                                                placeholder={t('editor.config.participant_email_placeholder')}
                                            />
                                        )}
                                    />
                                ) : (
                                    <Input
                                        disabled={disabled}
                                        readOnly={field.readonly}
                                        type="text"
                                        defaultValue={participant[field.name]}
                                        innerRef={register()}
                                        className="form-control input-sm"
                                        placeholder={t(`frontDesk.type_${field.name}`)}
                                        name={`${name}.${field.name}`}
                                    />
                                )}
                                <FormFeedback>{t('frontDesk.missing_field')}</FormFeedback>
                                
                                <div className="text-danger" hidden={!errors?.participants?.[participantIdx]?.[field.name]}>
                                    {/* {t(`errors.${errors?.participants?.[participantIdx]?.[field.name]?.message}`)} */}
                                    {t(`frontDesk.missing_field`)}
                                </div>
                            </FormGroup>
                        )}
                    )}
                    {hasAgendaFields && <p className="font-weight-bold mt-4">{t('Agenda')}</p> }
                    <input type="hidden" ref={register()} name={`${name}.agendaProperties.agendaId`} defaultValue={participant?.agendaProperties?.agendaId} />
                    {agendaFields.map(field => {
                        if (!agendaFieldsInDocument.some(a => a?.includes(field.propertyName))) return null;
                        return (
                            <div className="mb-2">
                                <label className="text-dark">{t(`agenda.${field.propertyName}_placeholder`)}</label>
                                {
                                    field.type === 'calendar' ?
                                     (
                                        <Controller
                                            control={control}
                                            name={`${name}.agendaProperties.${field.propertyName}`}
                                            defaultValue={getVariableDateValue({ value: participant?.agendaProperties?.[field.propertyName] }) || null}
                                            render={({ onChange, onBlur, value }) => (
                                                <DatePicker
                                                    disabled={disabled}
                                                    className="w-100"
                                                    locale={contract.language?.toLowerCase?.() || 'es'}
                                                    selected={value ? new Date(value) : null}
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    customInput={<input className="form-control input-sm" type="text" />}
                                                    dateFormat="PPP"
                                                    placeholderText={t(`agenda.${field.propertyName}_placeholder`)}
                                                />
                                            )}
                                        />
                                     )
                                    : (
                                        <Input
                                            disabled={disabled}
                                            readOnly={disabled}
                                            type="text"
                                            defaultValue={participant?.agendaProperties?.[field.propertyName] || ''}
                                            innerRef={register()}
                                            className="form-control input-sm"
                                            placeholder={t(`agenda.${field.propertyName}_placeholder`)}
                                            name={`${name}.agendaProperties.${field.propertyName}`}
                                        />
                                    )
                                }
                                <div className="text-danger" hidden={!errors?.participants?.[participantIdx]?.agendaProperties?.[field.propertyName]}>
                                    {/* {t(`errors.${errors?.participants?.[participantIdx]?.[field.name]?.message}`)} */}
                                    {t(`frontDesk.missing_field`)}
                                </div>
                            </div>
                        )
                    })}
                    <p className="font-weight-bold mt-4">{t('frontDesk.variables')}</p>
                    <Variables
                        disabled={disabled}
                        participant={participant}
                        documentLanguage={contract.language?.toLowerCase?.() || 'es'}
                        index={participantIdx}
                    />
                </CardBody>
            </Card>
        );
    };
//     (prevProps, nextProps) => prevProps.formState.isDirty === nextProps.formState.isDirty
// );

const loadDelegationRules = async () =>
    (await fetcher(fetchDelegationRulesUnpopulated())).map((doc) => ({
        label: doc.name,
        value: doc.user || doc.group,
        type: doc.group ? 'group' : 'user',
    }));

function Variables({ documentLanguage, participant, index, disabled }) {
    const { t } = useTranslation();
    const methods = useFormContext();
    return participant.usedVars?.length ? (
        participant.usedVars.map((foundVar) => {
            const variable = participant.variables.find((v) =>  v._id === foundVar._id || v.apiName === foundVar.apiName);
            return variable ?
                <Variable
                    disabled={disabled}
                    variable={variable}
                    key={variable._id}
                    documentLanguage={documentLanguage}
                    index={index}
                    participant={participant}
                    {...methods} /> :
                null;
        })
    ) : (
        t('frontDesk.empty')
    )
}

function Attachment({ attachment, isExtra, participant, errors = {}, register = noop, setValue = noop }) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const frontdeskState = useFrontDeskState();
    const { mutate: addAttachmentMutation } = useMutation((payload) => fetcher(contractAction(frontdeskState.contractId, 'addattachment', payload)), {
        onSuccess: () => {
            queryClient.invalidateQueries(['contract', frontdeskState.contractId]);
        },
    });
    const { mutate: updateAttachmentMutation } = useMutation(
        (payload) => fetcher(contractAction(frontdeskState.contractId, 'updateattachment', payload)),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['contract', frontdeskState.contractId]);
            },
        }
    );
    const uploadAttachment = ({ url, name, BaseFileName, ...rest }) => {
        console.log({url, name})
        if (attachment._id) {
            updateAttachmentMutation({
                attachment: { ...attachment, url: url, filename: name || BaseFileName },
                participantId: participant?._id,
            });
        } else {
            addAttachmentMutation({ ...rest, url, subject: name || BaseFileName, filename: name || BaseFileName, participantId: participant?._id });
        }
        setValue(`attachments.${attachment._id}`, name)
    }
    const hasAgendaDocuments = !!participant?.agendaProperties?.documents?.length;

    const { chooseFileAndUploadFile  } = useFileUpload({
        onSuccess: uploadAttachment,
    })
           

    const handleFile = async (files) => { 
        for (const file of files) {
            const result = await fetcher(uploadFileV2(file, noop, { 'X-Convert-TO-PDF': true }));
            uploadAttachment({ ...result, name: result.BaseFileName })
        }
    };

    const handleClick = (evt) => {
        
        
        console.log({hasAgendaDocuments})

        if (!isExtra && hasAgendaDocuments) {
            evt.preventDefault();
            evt.stopPropagation();
            return bootbox.dialog({
                title: 'Cargar documento desde',
                message: 'Elige el archivo a cargar',
                closeButton: true,
                buttons: {
                    // cancel: {
                    //     label: t('contracts.options.cancel'),
                    //     className: 'none btn-ligth',
                    //     callback: () => {
                            
                    //     },
                    // },
                    file: {
                        label: t('Mi equipo'),
                        className: 'btn-secondary',
                        color: 'secondary',
                        callback: async () => {
                                // const result = await fetcher(uploadFileV2(file));
                                // uploadAttachment({ ...result, name: result.BaseFileName })
                                chooseFileAndUploadFile({ convertToPdf: true }, {
                                    accept: '.pdf,image/*'
                                })
                        },
                    },
                    main: {
                        label: t('Agenda'),
                        color: 'primary',
                        callback: async () => {
                            const fileToUpload = await bootbox.prompt({
                                title: t('Selecciona el archivo'),
                                message: t('Selecciona el archivo'),
                                buttons: {
                                  cancel: { label: 'Cancelar', },
                                  confirm: { label: 'Aceptar', },
                                },
                                inputType: 'select',
                                inputOptions: participant?.agendaProperties?.documents?.map(doc => (
                                    { value: `${doc.name}|||${doc.url}`, label: doc.name }
                                )), 
                               
                              })
                              if (fileToUpload) {
                                const [docName, url] = fileToUpload.split('|||');
                                uploadAttachment({ url, name: docName  })
                              }
                              
                        },

                    },
                },
            });
        }
    }
    const downloadAttachment = () => {
        window.open(attachment.url);
    };
    return (
        <div>
            <input
                type="hidden"
                name={`attachments.${attachment._id}`}
                ref={register()}
                value={attachment?.filename}
            />
            {attachment?.url && (
                <div className="mb-3">
                    <Label htmlFor="exampleInputEmail1">
                        {attachment?.name} {attachment?.required && '(' + t('frontDesk.required') + ')'}
                    </Label>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <i className="fas fa-check text-success"></i>
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            readOnly={true}
                            type="text"
                            placeholder={t('frontDesk.select_file')}
                            value={attachment?.filename}
                        />
                        <div onClick={handleClick} >
                        <Dropzone noClick={!isExtra && hasAgendaDocuments} onDrop={(files) => handleFile(files)} multiple={false}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()} style={{ display: 'contents' }}>
                                    <input {...getInputProps()} />
                                    <Button color="secondary">
                                        {t('frontDesk.upload_again')}
                                    </Button>
                                </div>
                            )}
                        </Dropzone>
                        </div>
                        <Button color="secondary" onClick={downloadAttachment}>
                            <i className="fas fa-eye"></i>
                        </Button>
                    </InputGroup>
                </div>
            )}
            {(isExtra || !attachment?.url) && (
                <div onClick={handleClick} >
                    <DragZone
                        multiple={isExtra}
                        imgSrc="/images/listing/createDocument/subir.svg"
                        label={`${attachment?.name} ${attachment?.required ? '*' : ''}`}
                        className="frontdesk-drag"
                        acceptedFiles={fileTypes}
                        noClick={!isExtra && hasAgendaDocuments}
                        handleFile={handleFile}
                        onDrop={handleFile}
                    />
                </div>
            )}
            <div className="text-danger" hidden={!errors?.attachments?.[attachment._id]}> 
                    {t(`frontDesk.missing_field`)}
            </div>
        </div>
    );
}

function FooterBar({ formState: { isDirty, isValid }, control, reset, handleSave }) {

    const frontdeskState = useFrontDeskState();
    const dispatch = useFrontDeskDispatch();
    const queryClient = useQueryClient();
    const { profile } = useProfileState();
    const profileAbility = useProfileAbility();
    const methods = useFormContext();
    const [delegationRule, setDelegationRule] = useState();
    const history = useHistory();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch({ type: SET_MODIFIED, isModified: isDirty });
    }, [isDirty, dispatch]);

    const onSuccess = useCallback(() => {
        bootbox.alert({
            textT: 'frontDesk.delegate_success',
            translationParams: {
                values: { documentName: frontdeskState.contract?.name },
            },
        });
        queryClient.invalidateQueries('contracts-questionnaire');
        dispatch({ type: RESET });
    }, [dispatch, frontdeskState.contract?.name]);

    const onError = useCallback(
        (error) => {
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')));
        },
        [t]
    );

    const { mutate: delegateMutation } = useMutation((payload) => fetcher(contractAction(frontdeskState?.contractId, 'delegatecontract', payload)), {
        onSuccess,
        onError,
    });

    const { mutate: delegateGroupMutation } = useMutation(
        (payload) => fetcher(contractAction(frontdeskState?.contractId, 'delegatecontractgroup', payload)),
        {
            onSuccess,
            onError,
        }
    );

    const { mutate: workflowMutation } = useMutation((payload) => fetcher(contractAction(frontdeskState?.contractId, 'workflowactions', payload)), {
        onSuccess: async (response, payload) => {
            if (response.info) {
                if (await bootbox.confirm(t(`editor.info.${response.info}`))) {
                    workflowMutation({ ...payload, accept: true });
                }
            } else {
                await queryClient.invalidateQueries('contracts-questionnaire');
                bootbox.alert(t('workflow.init.success'));
                dispatch({ type: RESET });
                history.push('/frontdesk')
            }
        },
        onError: async (error) => {
             if (error.message === 'WorkflowStopped') {
                const resp = await bootbox.confirm(t('workflow.restart'));
                if (!resp) return;
                workflowMutation({ workflowAction: 'init', restart: true });
             } else {
                toast.error(t(`errors.${error.message}`, t('errors.GeneralError')));
             }
        },
    });

    const handleChangeDelegationRule = useCallback((option) => {
        setDelegationRule(option);
    }, []);

    const handlePreviewMode = useCallback(async () => {
        if (frontdeskState.isModified) {
            handleSave({
                onSuccess: () => {
                    dispatch({ type: SET_PREVIEW_MODE, preview_mode: true });
                }
            });
        } else {
            dispatch({ type: SET_PREVIEW_MODE, preview_mode: true });
        }
    }, [dispatch, frontdeskState.isModified, handleSave]);

    const doDelegate = () => {
        if (delegationRule.type === 'user') delegateMutation({ isApplication: true, newOwnerId: delegationRule.value, returnToLastDelegation: true });
        else if (delegationRule.type === 'group') delegateGroupMutation({ userGroup: delegationRule.value });
    }

    const handleSend = useCallback(
        async (e) => {
            e.preventDefault();
            if (!delegationRule) return bootbox.alert(t('frontDesk.missing_type'));
            const resp = await bootbox.confirm(t('frontDesk.confirm_save'));
            if (!resp) return;

            if (frontdeskState.contract?.validateRequiredFields) {
                const isValid = await methods.trigger();
            
                if (!isValid) return
            };
            if (frontdeskState.isModified) {
                handleSave({
                    onSuccess: () => {
                        doDelegate()
                    }
                })
            } else {
                doDelegate()
            }

        },
        [delegationRule, t, frontdeskState.isModified, handleSave, delegateMutation, delegateGroupMutation]
    );

    const handleInitWorkflow = useCallback(async (e) => {
        e.preventDefault();
        let isValid = true;
        if (frontdeskState.contract?.validateRequiredFields) {
            isValid = await methods.trigger();
        
            if (!isValid) return
        };
        if (frontdeskState.isModified) {
            handleSave({
                onSuccess: (savedContract) => {
                    if (!savedContract?.workflow) return toast.error(t('errors.MissingWorkflow'));
                    if (isValid) workflowMutation({ workflowAction: 'init' });
                }
            })
        } else {
            if (!frontdeskState.contract?.workflow) return toast.error(t('errors.MissingWorkflow'));
            if (isValid) workflowMutation({ workflowAction: 'init' });
        }
    }, [handleSave, isValid, t, workflowMutation]);

    const [workflowInitiated] = useState(
        frontdeskState.contract?.workflowStep > 0 ||
        frontdeskState.contract?.groups?.some(g => g.canOwn) ||
        frontdeskState.contract?.vobo?.some(g => g.status === 'sent' /*&& g.userGroup*/)
    )

    console.log({errors: methods.errors, values: methods.getValues()})

    return (
        <Row className="pt-2">
            <Col xs="4" md={profileAbility.can('SET_WORKFLOW_FRONTDESK') ? 3 : 6} hidden={profileAbility.can('INIT_WORKFLOW_FRONTDESK')}>
                <Form inline>
                    <FormGroup className="w-100">
                        <Label className="" htmlFor="exampleInputEmail2">
                            {t('frontDesk.application_type')}:
                        </Label>
                        <AsyncSelect
                            id="typeSelected"
                            name="typeSelected"
                            menuPlacement="auto"
                            className={clsx("select-frontdesk text-left", profileAbility.can('SET_WORKFLOW_FRONTDESK') ? "w-100" : "w-50")}
                            cacheOptions
                            isDisabled={workflowInitiated}
                            loadOptions={loadDelegationRules}
                            styles={reactSelectStyles}
                            defaultOptions
                            onChange={handleChangeDelegationRule}
                            noOptionsMessage={() => t('frontDesk.no_option')}
                            placeholder={t('frontDesk.no_option')}
                        />
                    </FormGroup>
                </Form>
             </Col>
            <Col xs="4" md={profileAbility.can('SET_WORKFLOW_FRONTDESK') ? 3 : 6} hidden={profileAbility.cannot('INIT_WORKFLOW_FRONTDESK') && profileAbility.cannot('SET_WORKFLOW_FRONTDESK') }>
                <Form inline>
                    <FormGroup className="w-100">
                        <Label for="workflowLabel" className="pr-2">{t('frontDesk.select_flow')}:</Label>
                        <Controller
                            control={control}
                            name="workflow"
                            render={({ onChange, onBlur, value }) => (
                                <WorkflowsSelect
                                    menuPlacement="auto"
                                    className={clsx("select-frontdesk", profileAbility.can('SET_WORKFLOW_FRONTDESK') ? "w-100" : "w-50")}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                     value={value}
                                    placeholder={t('workflow.choose')}
                                    isDisabled={workflowInitiated}
                                />
                            )}
                        />
                    </FormGroup>
                </Form>
            </Col>

            <Col className="align-self-center">
                <ButtonGroup className="d-flex">
                    <Button
                        size="sm"
                        className="mr-1"
                        onClick={handlePreviewMode}>
                        {t('frontDesk.previsualize')} <i className="pl-1 fas fa-eye"></i>
                    </Button>

                    <Button
                        size="sm"
                        className="mr-1"
                        color="primary"
                        onClick={handleSave}
                        disabled={workflowInitiated || frontdeskState.contract.status !== ''}>
                        {t('frontDesk.save')} <i className={clsx('pl-1 fas fa-save', { grow: frontdeskState.isModified })}></i>
                    </Button>

                    {profileAbility.can('INIT_WORKFLOW_FRONTDESK') ? (
                        <Button
                            size="sm"
                            color="success"
                            className="mr-1"
                            onClick={handleInitWorkflow}
                            disabled={workflowInitiated || frontdeskState.contract.status !== ''}>
                            {workflowInitiated ? t('frontDesk.workflow_initiated') : t('frontDesk.init_workflow')}<i className="fa fa-fw fa-check pl-1"></i>
                        </Button>
                    ) : (
                        <Button
                            size="sm"
                            color="success"
                            className="mr-1"
                            disabled={
                                frontdeskState.contract?.vobo?.some(g => g.status === 'sent' /*&& g.userGroup*/) ||
                                frontdeskState.contract?.groups?.some(g => g.canOwn) ||
                                ['SENT_TO_SIGN', 'SENT_TO_FILL', 'NEGOTIATE'].includes(frontdeskState.contract.status)}
                            onClick={handleSend}>
                            <i className="fa fa-fw fa-check"></i>
                            {t('frontDesk.send')}
                        </Button>
                    )}
                </ButtonGroup>
            </Col>
        </Row>
    );
}

function ExtraAttachments({ contract }) {
    const { t } = useTranslation();
    return (
        <>
            {contract?.extraAttachments?.length ? contract?.extraAttachments.map((extra) => <Attachment key={extra._id} attachment={extra} />) : null}
            <Attachment attachment={{ name: t('frontDesk.extra_attachments') }} isExtra={true} />
        </>
    );
}

export function Contract() {

    const methods = useFormContext();
    const { t } = useTranslation();

    const { contract = {}, isModified } = useFrontDeskState();

    const queryClient = useQueryClient();
    const { getWhoamiFor } = useWhoami();

    const editor = useConstant(() => getEditorInstance({}));

    const { mutate: mutateContract } = useMutation((payload) => fetcher(saveContract(payload)), {
        onSuccess: (data) => {
            toast.success(t('messages.successfullyUpdated'))
            queryClient.invalidateQueries('contracts-questionnaire');
            queryClient.setQueryData(['contract', contract._id], data);
            queryClient.invalidateQueries(['contract', contract._id]);
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`), t('errors.GeneralError'));
        }
    });

    const handleSave = useCallback(async ({ onSuccess, onError }) => {
        const form = methods.getValues();
        const whoami = getWhoamiFor(contract);
        if (whoami.someoneApproved()) {
           const resp = await bootbox.confirm(t('editor.action.reapprove'));
           if (!resp) return;
        }

        return mutateContract({
            _id: contract._id,
            name: form.name,
            participants: contract.participants.map((p) => {
                const foundParticipant = form.participants.find((fp) => fp._id === p._id)

                return {
                    ...p,
                    ...foundParticipant,
                    agendaProperties: {
                        ...(p?.agendaProperties || {}),
                        ...(foundParticipant?.agendaProperties || {}),
                        // documents: foundParticipant?.agendaProperties?.documents ? JSON.parse(foundParticipant?.agendaProperties?.documents) : []
                    }
                }
            }),
            computedVariables: form.computedVariables,
            workflow: form.workflow || null,
        }, { onSuccess, onError });
    }, [contract, methods, mutateContract]);

    if (!contract._id) return null;

    return (
        <div className="d-flex flex-column h-100 overflow-hidden">
            <div className="overflow-hidden d-flex flex-column h-100">
                <div className="mb-2">
                    <InputGroup className="">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                {isModified ?
                                    <i className="fas fa-exclamation text-danger"></i> :
                                    <i className="fas fa-pen"></i>
                                }
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            disabled={contract.workflowStep > 0 || contract.groups?.some(g => g.canOwn) || contract?.vobo?.some(g => g.status === 'sent' /*&& g.userGroup*/)}
                            style={{ width: 'calc(100% - 200px)' }}
                            className="document-name"
                            innerRef={methods.register}
                            type="text"
                            name="name"
                            defaultValue={contract?.name}
                        />
                    </InputGroup>
                </div>
                <div className="overflow-hidden h-100">
                    <Row className="h-100">
                        <Col md="6" className="h-100 overflow-auto">
                            <h5 className="font-weight-bold">{t('frontDesk.participants')}</h5>
                            <Slate editor={editor} value={contract.elements} onChange={() => { }}>
                            {contract?.participants?.map((participant, index) => (
                                <Participant
                                    disabled={contract.workflowStep > 0 || contract.groups?.some(g => g.canOwn) || contract?.vobo?.some(g => g.status === 'sent' /*&& g.userGroup*/)}
                                    index={index}
                                    key={participant._id}
                                    participant={participant}
                                    name={`participants[${index}]`}
                                    contract={contract}
                                    contractId={contract._id}
                                    {...methods}
                                />
                            ))}
                            </Slate>
                        </Col>
                        <Col md="6" className="h-100 overflow-auto">
                            <h5 className="font-weight-bold">{t('frontDesk.attachments')}</h5>
                            {contract?.participants?.map((participant) => (
                                <Card className="mb-2 rounded-lg" key={participant._id}>
                                    <CardHeader className="bg-light font-weight-bold rounded-lg-top text-center">{participant.label}</CardHeader>
                                    <CardBody className="" key={'participant-item-' + participant._id}>
                                        {participant.attachments?.length
                                            ? participant.attachments.map((attachment) => (
                                                <Attachment attachment={attachment} key={attachment._id} participant={participant}  {...methods} />
                                            ))
                                            : t('frontDesk.empty_attachment')}
                                    </CardBody>
                                </Card>
                            ))}
                            <Card className="mb-2 bg-light rounded-lg">
                                <CardHeader className="bg-light font-weight-bold rounded-lg-top text-center">{t('frontDesk.extra_attachments')}</CardHeader>
                                <CardBody className="">
                                    <ExtraAttachments contract={contract} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div>
                    <FooterBar handleSave={handleSave} {...methods} />
                </div>
            </div>
        </div>
    );
}

export function ContractItem({ contract, isActive }) {
    const methods = useFormContext();
    const { status, createdAt, name, user, _id, documentId, groups, vobo } = contract;
    const { t } = useTranslation();
    const dispatch = useFrontDeskDispatch();
    const queryClient = useQueryClient();
    const history = useHistory();
    const frontdeskState = useFrontDeskState();
    const { mutate: deleteMutation } = useMutation(() => fetcher(contractAction(frontdeskState.contractId, 'remove')), {
        onSuccess: async () => {
            await queryClient.invalidateQueries('contracts-questionnaire');
            history.push(`/frontdesk/contract/${_id}`);
            dispatch({ type: SET_DETAIL_OPEN, isContractDetailOpen: false });
        },
        onError: (error) => {
            toast.error(t('errors.' + error.message), t('errors.GeneralError'));
        },
    });

    const showDelete = async () => {
        if (await bootbox.confirm(t('contracts.options.delete_confirm'))) {
            deleteMutation();
        }
    };

    const confirmClose = async () => {
        if (frontdeskState.isModified && !(await bootbox.confirm(t('frontDesk.confirm_close')))) {
            return false;
        }
        return true;
    }

    const showTimeline = useCallback(async () => {
        if (await confirmClose()) {
            dispatch({ type: TOGGLE_SET_DETAIL_OPEN });
        }
    }, [confirmClose]);

    const handleSetContractId = useCallback(async () => {
        if (frontdeskState.contractId !== _id && await confirmClose()) {
            history.push(`/frontdesk/contract/${_id}`);
            methods.reset()
        }
    }, [_id, frontdeskState.contractId, frontdeskState.isModified]);

    return (
        <Card className={clsx('pointer bg-white my-2 rounded-lg', isActive && 'shadow')} onClick={handleSetContractId}>
            <CardBody>
                <div className="d-flex">
                    <div className="flex-grow-1 align-self-center font-weight-bold text-truncate">
                        {documentId} - {name}
                    </div>
                    <div className="flex-grow-1 d-flex justify-content-end" style={{minWidth:"91px"}}>
                        <Button size="sm" color="default" id="vobos" hidden={!vobo.length} className="text-muted">
                            {vobo?.filter(v => v.status === 'approved').length} <i className="fas fa-thumbs-up"></i>{' '}
                            {vobo?.filter(v => v.status === 'rejected').length} <i className="fas fa-thumbs-down"></i>{' '}
                            {vobo?.filter(v => v.status === 'sent').length} <i className="fas fa-question"></i>{' '}
                        </Button>
                        <Button size="sm" color="default" onClick={showTimeline} className="float-right text-muted p-0 border-0" style={{position: "absolute", right: "2px", top:"23px"}}>
                            <i className={clsx('fas fa-code-branch', isActive || 'd-none')}></i>
                        </Button>
                        <Button size="sm" color="default" onClick={showDelete} className="float-right text-muted p-0 border-0" style={{position: "absolute",top: "0px", right: "0px"}}>
                            <i className={clsx('fas fa-times-circle text-danger', isActive || 'd-none')}></i>
                        </Button>
                    </div>
                </div>
                <hr className=""></hr>
                <CardText
                    className={groups?.find((g) => g.canOwn) ? 'mb-2' : 'd-none'}
                    title={t('frontDesk.waitingGrab')}
                    style={{ display: 'table' }}
                >
                    <i className="fas fa-hand-paper"></i>
                    <small className="ml-1">{t('frontDesk.waitingGrab')}</small>
                </CardText>
                <CardText>{t(`contracts.status.${status}`)}</CardText>
                <CardText>{parseDate(createdAt, 'PP')}</CardText>

                <CardText>
                    {user?.givenName} {user.familyName}
                </CardText>

                <UncontrolledCollapse toggler="#vobos">
                    <CardText
                        className='mb-2'
                        style={{ display: 'table' }}
                    >
                        {vobo?.map((v) => <Vobo vobo={v} />)}
                    </CardText>
                </UncontrolledCollapse>
            </CardBody>
        </Card>
    );
}
